import { useEffect, useState } from '@max/max';
import { useMonitorEngineContext } from '@nibfe/mcp-monitor-sdk';
import { useRequest } from './useRequest';
import { API_PATH } from '../types/shared';
import { getRequestBaseParams } from '../utils/request';
export function useLeaderboardNotice(options) {
    const ctx = useMonitorEngineContext();
    const commonParams = ctx._runtimeInfo?.commonParams;
    const [leaderboardItems, setLeaderboardItems] = useState([]);
    const { request } = useRequest(API_PATH.FREE_ORDER_CARD_LEADERBOARD);
    async function loadLeaderboardData() {
        try {
            const feCommonParams = await getRequestBaseParams(commonParams);
            const res = await request({
                ...feCommonParams,
                activityId: options.activityId
            });
            if (Array.isArray(res?.leaderboardItems)) {
                const validData = res.leaderboardItems.filter(item => item.userName && item.invitedCount);
                setLeaderboardItems(validData);
            }
            ctx._raptorReport.monitorReportBizSuccess?.({
                apiPath: API_PATH.FREE_ORDER_CARD_LEADERBOARD
            });
        }
        catch (error) {
            ctx._raptorReport.monitorReportBizFailed?.({
                apiPath: API_PATH.FREE_ORDER_CARD_LEADERBOARD
            });
            ctx._raptorReport.monitorReportLog(error.message, error, {
                category: 'ajaxError',
                level: 'error'
            });
        }
    }
    useEffect(() => {
        loadLeaderboardData();
    }, [options.activityId]);
    return {
        leaderboardItems,
        loadLeaderboardData
    };
}
